import { ResourceDto, ResourceGroupDto } from 'types';

export interface IGroupResource extends ResourceGroupDto {
  label: string;
  value: string;
  resources: ResourceDto[];
}

export type WebhookHttpMethod = 'POST' | 'PUT' | 'PATCH';

export const WEBHOOK_HTTP_METHODS: WebhookHttpMethod[] = ['POST', 'PUT', 'PATCH'];

export type WebhookEventType = 'WORK_ORDER_MARKED_READY';

export const WEBHOOK_EVENTS: { value: WebhookEventType; label: string }[] = [
  { value: 'WORK_ORDER_MARKED_READY', label: 'Work Order marked READY' },
];

export const WEBHOOK_EVENT_LABELS: Record<WebhookEventType, string> = {
  WORK_ORDER_MARKED_READY: 'Work Order marked READY',
};

export interface IUserSnapshot {
  _id: string;
  fullName: string;
}

export interface IWebhookDto {
  _id: string;
  name: string;
  url: string;
  method: WebhookHttpMethod;
  events: WebhookEventType[];
  isActive: boolean;
  createdBy?: IUserSnapshot;
  updatedBy?: IUserSnapshot;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateWebhookDto {
  name: string;
  url: string;
  method: WebhookHttpMethod;
  events: WebhookEventType[];
  isActive: boolean;
}

export interface IUpdateWebhookDto {
  name?: string;
  url?: string;
  method?: WebhookHttpMethod;
  events?: WebhookEventType[];
  isActive?: boolean;
}
